import { EmblaCarouselType } from 'embla-carousel';
import { useCallback } from 'react';

import ArrowIcon from '@/fo/icons/base/icons/arrow24.svg';
import { UiKitButtonBase } from '@/fo/ui/kit/button/base';

import { styles } from './Arrows.styles';

type UsePrevNextButtonsType = {
  onPrevButtonClick: () => void;
  onNextButtonClick: () => void;
};

export const usePrevNextButtons = (
  emblaApi: EmblaCarouselType | undefined,
  onButtonClick?: (emblaApi: EmblaCarouselType) => void
): UsePrevNextButtonsType => {
  const onPrevButtonClick = useCallback(() => {
    if (!emblaApi) return;
    emblaApi.scrollPrev();
    if (onButtonClick) onButtonClick(emblaApi);
  }, [emblaApi, onButtonClick]);

  const onNextButtonClick = useCallback(() => {
    if (!emblaApi) return;
    emblaApi.scrollNext();
    if (onButtonClick) onButtonClick(emblaApi);
  }, [emblaApi, onButtonClick]);

  return {
    onPrevButtonClick,
    onNextButtonClick
  };
};

export interface ArrowsProps {
  className?: string;
  onClick?: () => void;
}

export function PrevButton({ className, ...props }: ArrowsProps) {
  const slots = styles({});

  return (
    <UiKitButtonBase
      {...props}
      className={slots.arrow({
        className: ['left-6 rotate-180', className]
      })}
      rounded="full"
      color="outlined"
    >
      <ArrowIcon />
    </UiKitButtonBase>
  );
}

export function NextButton({ className, ...props }: ArrowsProps) {
  const slots = styles({});

  return (
    <UiKitButtonBase
      {...props}
      className={slots.arrow({
        className: ['right-6', className]
      })}
      rounded="full"
      color="outlined"
    >
      <ArrowIcon />
    </UiKitButtonBase>
  );
}
